/**
 * Shared state for authentication data to avoid circular dependencies
 * This allows LanguageService to access isLocal without depending on AuthenticationService
 */
class AuthenticationState {
  private isLocal: boolean = false;

  public setIsLocal(isLocal: boolean): void {
    this.isLocal = isLocal;
  }

  public getIsLocal(): boolean {
    return this.isLocal;
  }
}

export const authenticationState = new AuthenticationState();
